import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrderStatusResolver } from './guards/order-status.resolver.guard';
import { OrderStatusLayoutComponent } from './layout/order-status/order-status-layout.component';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                component: OrderStatusLayoutComponent,
                resolve: [OrderStatusResolver],
            },
        ],

    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class OrderStatusRoutingModule {}
